import { gql, useReactiveVar, makeVar } from "@apollo/client";
import { DateTime } from "luxon";
import { fulfillmentScreenQueryVar } from "../components/FulfillmentScreen";
import { useMarkAllAsFulfilledMutation, useArchiveAllMutation } from "../types";
export const fulfillmentFilterMapper = (v) => {
    switch (v) {
        case true:
            return "true";
        case false:
            return "false";
        default:
            return "all";
    }
};
export const fulfillmentFilterMapperReverse = (v) => {
    switch (v) {
        case "true":
            return true;
        case "false":
            return false;
        default:
            return undefined;
    }
};
export const useUpdateFulfillmentMemberSearch = () => {
    const fulfillmentQuery = useReactiveVar(fulfillmentScreenQueryVar);
    return (ev) => {
        fulfillmentScreenQueryVar(Object.assign(Object.assign({}, fulfillmentQuery), { memberSearch: ev.target.value.trim() }));
    };
};
export const useUpdateFulfillmentValue = (field) => {
    const fulfillmentQuery = useReactiveVar(fulfillmentScreenQueryVar);
    return (ev) => {
        fulfillmentScreenQueryVar(Object.assign(Object.assign({}, fulfillmentQuery), { [field]: ev.target.value }));
    };
};
export const useUpdateFulfillmentQuery = (field) => {
    const fulfillmentQuery = useReactiveVar(fulfillmentScreenQueryVar);
    return (ev) => {
        fulfillmentScreenQueryVar(Object.assign(Object.assign({}, fulfillmentQuery), { [field]: fulfillmentFilterMapperReverse(ev.target.value) }));
    };
};
export const useUpdateFulfillmentDateFilter = () => {
    const fulfillmentQuery = useReactiveVar(fulfillmentScreenQueryVar);
    return (t) => {
        return (value) => {
            if (value === null || value === undefined) {
                fulfillmentScreenQueryVar(Object.assign(Object.assign({}, fulfillmentQuery), { [t]: undefined }));
            }
            else {
                fulfillmentScreenQueryVar(Object.assign(Object.assign({}, fulfillmentQuery), { [t]: DateTime.fromISO(value.toISOString()).toSQLDate() }));
            }
        };
    };
};
export const useGetFulfillmentDates = () => {
    const fulfillmentQuery = useReactiveVar(fulfillmentScreenQueryVar);
    return [
        fulfillmentQuery.start && new Date(DateTime.fromSQL(fulfillmentQuery.start).toISO()),
        fulfillmentQuery.end && new Date(DateTime.fromSQL(fulfillmentQuery.end).toISO()),
    ];
};
gql `
  mutation MarkAllAsFulfilled($sendNotification: Boolean, $query: FulfillmentQuery!) {
    fulfillmentBatchMarkFulfilled(sendNotification: $sendNotification, query: $query) {
      ...FulfillmentLine
    }
  }

  mutation ArchiveAll($query: FulfillmentQuery!) {
    fulfillmentBatchArchive(query: $query) {
      ...FulfillmentLine
    }
  }
`;
// KGAUDIT - what's the difference between makeVar and useReactiveVar
export const fulfillmentScreenSendNotificationVar = makeVar(true);
export const useMarkAllAsFulfilled = (id) => {
    const fulfillmentQuery = useReactiveVar(fulfillmentScreenQueryVar);
    const fulfillmentScreenSendNotification = useReactiveVar(fulfillmentScreenSendNotificationVar);
    const [original, result] = useMarkAllAsFulfilledMutation({
        variables: {
            sendNotification: fulfillmentScreenSendNotification,
            query: Object.assign(Object.assign({}, fulfillmentQuery), { businessId: id })
        }
    });
    // KGAUDIT - I have no idea what's going on here.
    const wrapped = () => {
        return original();
    };
    return { wrapped, original, result };
};
export const useArchiveAll = (id) => {
    const fulfillmentQuery = useReactiveVar(fulfillmentScreenQueryVar);
    const [original, result] = useArchiveAllMutation({
        variables: {
            query: Object.assign(Object.assign({}, fulfillmentQuery), { businessId: id })
        }
    });
    // KGAUDIT - I have no idea what's going on here.
    const wrapped = () => {
        return original();
    };
    return { wrapped, original, result };
};
